import { render, staticRenderFns } from "./MealRecipesLoading.vue?vue&type=template&id=a9fcd862&scoped=true&"
import script from "./MealRecipesLoading.vue?vue&type=script&lang=js&"
export * from "./MealRecipesLoading.vue?vue&type=script&lang=js&"
import style0 from "./MealRecipesLoading.vue?vue&type=style&index=0&id=a9fcd862&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9fcd862",
  null
  
)

export default component.exports